export class ReceiptNotificationModel {
  public PartyId: string;
  public LastPaidDate: number;
  public ReceiptDate: number;
  public DueAmount: number;
  public isDone: boolean;
  public isPurch: boolean;
}
